import routerMap from '../config/routerConfig.json';

const isServiceActiveByPathname = service => {
  const currentHostName = window.location.hostname;

  if (!routerMap[service]) {
    return false;
  }

  if (service !== 'integrations') {
    return routerMap[service].firstLevel.includes(currentHostName);
  }

  for (let i = 0; i < routerMap[service].exceptions.length; i++) {
    let exception = routerMap[service].exceptions[i];

    if (exception.includes('/*')) {
      exception = exception.replace('/*', '');
      if (window.location.pathname.startsWith(exception)) {
        return false;
      }
    } else {
      if (window.location.pathname === exception) {
        return false;
      }
    }
  }

  return routerMap[service].firstLevel.includes(currentHostName);
};

const isDropdownItemActive = (service, serviceTitle) => {
  // Email marketing is special, because it has a hash in the URL instead of a pathname
  const currentActivePage =
    service === 'email_marketing' ? window.location.hash : window.location.pathname;
  if (!isServiceActiveByPathname(service)) {
    return false;
  }

  if (routerMap[service] && routerMap[service].secondLevel[serviceTitle]) {
    // We need an exact match for the pathname
    const secondLevelKeyword = routerMap[service].secondLevel[serviceTitle];

    // if secondLevelKeyword is an array, we need to check if the current pathname is in the array
    if (Array.isArray(secondLevelKeyword)) {
      // we have to iterate over the array to check if the current pathname is in the array.
      // If one of the items in the array has a wildcard after the slash, we only need to check if the first segment of the current pathname matches with the item without the slash.
      for (let i = 0; i < secondLevelKeyword.length; i++) {
        const currentKeyword = secondLevelKeyword[i];
        if (currentKeyword.includes('/*')) {
          const secondLevelCurrentRoot = currentKeyword.replace('/*', '');

          if (currentActivePage.startsWith(secondLevelCurrentRoot)) {
            return true;
          }
        }

        if (currentActivePage === currentKeyword) {
          return true;
        }
      }

      return false;
    }

    return secondLevelKeyword === currentActivePage;
  }

  return false;
};

export { isServiceActiveByPathname, isDropdownItemActive };
